import Image from "@/components/Image";
import Masonry from "@/components/Masonry";
import { getSimiliarMaterial } from "@/services";
import { getContentType } from "@/utils/getContentType";
import imageUrl from "@/utils/imageUrl";
import useRequest from "@/utils/useReq";
import Link from "next/link";
import { useCallback, useEffect, useRef, useState } from "react";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

const scrollableTarget = "similarMaterialList";

export default function SimilarMaterialList({
  initList,
  material_id,
  pin_id,
  onSelect,
  className = "",
  style = {},
}) {
  const initRef = useRef(true);
  const [visable, setVisable] = useState(true);
  const { data, error, loading } = useRequest(
    async () => {
      if (initRef.current && initList) {
        initRef.current = false;
        return;
      }

      return getSimiliarMaterial({ pin_id }).then((data) => {
        if (data.pins) {
          return {
            pins: data.pins.filter((item) => !!item),
          };
        } else {
          return data;
        }
      });
    },
    {
      refreshDeps: [pin_id],
    }
  );

  const render = useCallback(
    (pin) => {
      return (
        <div key={pin.pin_id}>
          <a
            className={styles.item}
            href={`/pins/${pin.pin_id}`}
            onClick={(e) => {
              if (e.metaKey || e.ctrlKey) {
                return;
              }
              e.preventDefault();
              onSelect(
                pin,
                imageUrl(pin.file, { width: 100 }),
                "similarMaterial"
              );
            }}
            data-gd-expose="content_expose"
            data-gd-click="material_click"
            data-content-id={pin.pin_id}
            data-content-type={getContentType(pin?.extra)}
            data-material-id={pin.extra?.material_id}
            data-board-id={pin.board_id}
            data-file-id={pin.file_id}
            data-ext={JSON.stringify(pin?.ext)}
          >
            <Image
              onLoad={(evt) => {
                const target = evt.target;
                target?.classList.add("transparent-img-bg");
              }}
              src={imageUrl(pin.file, { width: 100 })}
              width={100}
              height={Math.round((pin.file?.height / pin.file?.width) * 100)}
              alt={pin.raw_text}
              showError={true}
            />
          </a>
        </div>
      );
    },
    [onSelect]
  );

  const renderListData = data?.pins || initList || [];
  useEffect(() => {
    if (!loading) {
      const renderListData = data?.pins || initList || [];
      if (error || data?.err || renderListData.length === 0) {
        setVisable(false);
        if (error || data?.err) {
          console.error(error || data?.err);
        }
      } else {
        setVisable(true);
      }
    }
  }, [data, error, initList, loading]);
  return (
    <>
      {visable && (
        <div className={className} style={style}>
          <div className={styles.similar} data-content-source="相似商用素材">
            <div className={styles.header}>
              <Link href={`/pins/${pin_id}/similar/materials`}>
                <a
                  target={"_blank"}
                  className={styles.title}
                  data-gd-click="button_click"
                  data-button-name="更多相似商用素材"
                  data-material-id={material_id}
                  rel="nofollow"
                >
                  相似商用素材
                </a>
              </Link>
              I<span className={styles.sub}>源文件可下载编辑</span>
              <Link href={`/pins/${pin_id}/similar/materials`}>
                <a
                  target={"_blank"}
                  className={styles.more}
                  data-gd-click="button_click"
                  data-button-name="更多相似商用素材"
                  data-material-id={material_id}
                  rel="nofollow"
                >
                  更多
                  <HBIcon type="ic_chevron_right" />
                </a>
              </Link>
            </div>
            <div id={scrollableTarget} className={styles.list}>
              {loading ? (
                <>
                  {Array(3)
                    .fill(0)
                    .map((i, index) => (
                      <div className={styles.skeleton} key={index}></div>
                    ))}
                </>
              ) : (
                <>
                  <Masonry
                    bricks={renderListData}
                    brickId="pin_id"
                    scrollElement={scrollableTarget}
                    render={render}
                    columnNum={3}
                    threshold={800}
                    gutter={6}
                    columnSize={100}
                  />
                  <Link href={`/pins/${pin_id}/similar/materials`}>
                    <a
                      target={"_blank"}
                      className={styles.footer}
                      data-gd-click="button_click"
                      data-button-name="更多相似商用素材"
                      data-material-id={material_id}
                      rel="nofollow"
                    >
                      查看更多
                      <HBIcon type="ic_chevron_right" />
                    </a>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
